import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import cr from "../lib/request";
import ComponentSpinner from "../components/ComponentSpinner";
import CourseManfaatEditor from "../components/courseComponents/CourseManfaatEditor";

export default function CourseManfaatEdit() {
  const [data, setData] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setLoading(true);
      const url = `api/course/${id}/getbenefit`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  return !loading ? (
    <CourseManfaatEditor data={data} id={id} />
  ) : (
    <ComponentSpinner />
  );
}
